<template>
  <v-card flat>
    <v-card-title class="theme px-3 py-0 white--text">
      <v-row>
        <v-col cols="12">
          <div class="my-2">
            <span class="headline white--text">{{ company.name }}</span>
            <router-link
                :to="{ name: 'CompanyInfo' }"
                class="white--text text-uppercase mr-3"
                style="
                float: right;
                text-decoration: none;
                cursor: pointer;
                font-size: 14px;
              "
            >Edit
            </router-link>
          </div>

          <div style="float: left">
            <div>
              <v-icon small class="white--text mr-2">web</v-icon>
              :<span class="body-1">{{ company.url ? company.url : 'NA' }}</span>
            </div>
            <div>
              <v-icon small class="white--text mr-2">apartment</v-icon>
              :<span class="body-1">{{ company.org_nr ? company.org_nr : 'NA' }}</span>
            </div>
            <div>
              <v-icon small class="white--text mr-2">email</v-icon>
              :<span class="body-1">{{ company.contact_email ? company.contact_email : 'NA' }}</span>
            </div>
            <div>
              <v-icon small class="white--text mr-2">call</v-icon>
              :
              <span class="body-1">
                {{ company.contact_isd && company.contact_phone ? company.contact_isd + ' ' + company.contact_phone : 'NA' }}
              </span>
            </div>
            <div>
              <v-icon small class="white--text mr-2">location_on</v-icon>
              :<span class="body-1">{{ company.location ? company.location : 'NA' }}</span>
            </div>
          </div>
          <div style="float: right" class="hidden-md-and-down">
            <v-avatar size="150" v-if="company.logo_url">
              <v-img :src="company.logo_url"></v-img>
            </v-avatar>
          </div>
        </v-col>
        <v-col class="mt-0 mb-2" cols="12" v-if="companyTimeline">
          <div class="title">Latest company updates & changes</div>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-timeline align-top dense v-if="companyTimeline">
        <v-timeline-item
          dense
          color="action"
          icon="timeline"
          v-for="(item, i) in companyTimeline"
          :key="i"
        >
          <v-row class="mt-n3">
            <v-col>
              <div>
                <strong>{{ item.date ? item.date : "" }}</strong>
              </div>
              <div>{{ item.title }}</div>
              <!--              <div>{{ item.description }}</div>-->
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex';

import {Actions}    from '@/views/actions';
import {Component}  from '@/views/component';
import {Constants}  from '@/views/constants';

export default {
  name: Component.Protected.Company.Info,
  computed: {
    ...mapGetters(['company', 'companyTimeline']),
  },
  methods: {
    edit() {
      if (!this.company.id) {
        this.snackbar = true;
        this.snackbarMessage =
          Constants.Company.Messages.Error.CompanyIDNotFound;
        return false;
      }

      // todo : add general information component
      this.$router.push({ name: Component.Protected.Company.General });
    },
  },
  created() {
    this.$store.dispatch(Actions.CompanyTimeline);
  },
};
</script>

<style scoped>
div.v-card {
  border-radius: 5px;
}
</style>